import React from 'react';
import * as Sentry from '@sentry/react';
import { Button } from '@mes-amis/galette-design-system';

export default function DeveloperTab() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h2 className="text-base font-semibold text-gray-900 mb-4">Sentry Error Tracking</h2>
      <p className="text-sm text-gray-600 mb-4">
        Test that Sentry is receiving errors from this application.
      </p>
      <div className="flex gap-3">
        <Button
          variant="primary"
          destructive
          size="sm"
          onClick={() => {
            throw new Error('This is your first error!');
          }}
        >
          Break the world
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={() => Sentry.captureMessage('Test message from Settings', 'info')}
        >
          Send test message
        </Button>
      </div>
    </div>
  );
}
